import { createApiAction } from '@app/packages/api/utils'
import type { ApiNotificationSubscription } from '@app/packages/api/v2/types/entities'
import { v2Path } from '@app/packages/api/v2/utils'

export const getNotificationSubscriptions = () =>
  createApiAction('getNotificationSubscriptions', dispatch =>
    dispatch<{ data: ApiNotificationSubscription[] }>({ method: 'GET', endpoint: '/api/v2/notification_subscriptions' })
  )

export const postNotificationSubscriptions = (topic: string, channel: string) =>
  createApiAction('postNotificationSubscriptions', dispatch =>
    dispatch<{ data: ApiNotificationSubscription }>({
      method: 'POST',
      endpoint: '/api/v2/notification_subscriptions',
      body: JSON.stringify({ topic, channel }),
    })
  )

export const deleteNotificationSubscriptions = (topic: string, channel: string) =>
  createApiAction('deleteNotificationSubscriptions', dispatch =>
    dispatch<{ data: ApiNotificationSubscription }>({ method: 'DELETE', endpoint: v2Path('/api/v2/notification_subscriptions', { topic, channel }) })
  )
